export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/3fadfda14f341399d663fd2ed398d959.svg";